URL = '/keepcon/settings/account_setting/allowed_domains'
class AccountSettings.AllowedDomain extends Backbone.Model
  urlRoot: URL

  getDomain: ->
    @get('domain')

  setDomain: (domain) ->
    @set('domain', domain)

  getId: ->
    @get('id')

  setId: (id) ->
    @set('id', id)

class AccountSettings.AllowedDomainCollection extends Backbone.Collection
  model: AccountSettings.AllowedDomain
  url: URL
